module.exports = __webpack_public_path__ + "static/img/5.114bcd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/5.png
// module id = fYAH
// module chunks = 2